import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  useTheme,
} from "@mui/material";
import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useUpdateEnquiryMutation, useCloseEnquiryMutation } from "state/api";
import { useFormik } from "formik";
import { validationSchemaUpdate } from "../AddEnquiry/validationSchema";
import {
  customerResponses,
  callStatuses,
  budgetRanges,
  leadStatus
} from "../AddEnquiry/enquiryDropdowns";
const styles = {
  button: "bg-[#3671D5] hover:bg-[#114AAA] text-white ",
  cancelBtn: "bg-red-500 hover:bg-red-600 text-white",
};

const AddNewFollowUp = ({ id, data }) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      id: id,
      callStatus: "",
      nextFollowUpDate: null,
      customerResponse: customerResponses[0],
      budget: data.budget,
      leadStatus: "",
      remarks: "",
    },
    validationSchema: validationSchemaUpdate,
    onSubmit: (values) => {
      // submit the form using rtk query mutation and close the dialog
      updateEnquiry(values)
        .unwrap()
        .then((res) => {
          alert("Enquiry added successfully");
        })
        .catch((err) => {
          alert("Error adding enquiry");
        });
      // above code can be replaced with a toast notification

      //   reset the form fields
      formik.resetForm({
        id: id,
        callStatus: "",
        nextFollowUpDate: null,
        customerResponse: customerResponses[0],
        budget: data.budget,
        leadStatus: "",
        remarks: "",
      });
      setOpen(false);
    },
  });
  const [updateEnquiry] = useUpdateEnquiryMutation(formik.values);
  const [closeEnquiry] = useCloseEnquiryMutation(formik.values.id);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseEnquiry = () => {
    // close the enquiry
    closeEnquiry({ id: id })
      .unwrap()
      .then((res) => {
        alert("Enquiry closed successfully");
      })
      .catch((err) => {
        alert("Error closing enquiry");
      });
    // above code can be replaced with a toast notification
  };

  return (
    <>
      {/* Flex row for multiple buttons */}
      <div className="flex flex-row gap-2">
        <Button
          variant="contained"
          className="bg-blue-600 hover:bg-blue-700 text-gray-50"
          onClick={handleClickOpen}
        >
          Add &nbsp; Follow &nbsp; Up
        </Button>
        <Button
          variant="contained"
          className="bg-slate-500 hover:bg-slate-600 text-gray-50"
          onClick={handleCloseEnquiry}
        >
          Close &nbsp; Enquiry
        </Button>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
          // change label color
          "& .MuiInputLabel-root": {
            color: theme.palette.primary[300],
          },
        }}
        maxWidth="md"
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle id="form-dialog-title">Update Enquiry</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please enter the details here. All fields are mandatory.
            </DialogContentText>
            {/* place all input fields in the grid of 2 */}
            <div className="grid grid-cols-1 gap-4 mt-1 mb-4">
              <Autocomplete
                margin="dense"
                id="callStatus"
                options={callStatuses}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("callStatus", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Call Status"
                    error={
                      formik.touched.callStatus &&
                      Boolean(formik.errors.callStatus)
                    }
                    helperText={
                      formik.touched.callStatus && formik.errors.callStatus
                    }
                  />
                )}
              />
              <Autocomplete
                margin="dense"
                id="customerResponse"
                options={customerResponses}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("customerResponse", newValue);
                }}
                defaultValue={customerResponses[0]}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Customer Response"
                    error={
                      formik.touched.customerResponse &&
                      Boolean(formik.errors.customerResponse)
                    }
                    helperText={
                      formik.touched.customerResponse &&
                      formik.errors.customerResponse
                    }
                  />
                )}
              />
              <Autocomplete
                margin="dense"
                id="budget"
                options={budgetRanges}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("budget", newValue);
                }}
                defaultValue={data.budget}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Budget"
                    error={
                      formik.touched.budget && Boolean(formik.errors.budget)
                    }
                    helperText={formik.touched.budget && formik.errors.budget}
                  />
                )}
              />
              <Autocomplete
                margin="dense"
                id="leadStatus"
                options={leadStatus}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("leadStatus", newValue);
                }}
                defaultValue={leadStatus[0]}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Lead Status"
                    error={
                      formik.touched.leadStatus && Boolean(formik.errors.leadStatus)
                    }
                    helperText={formik.touched.leadStatus && formik.errors.leadStatus}
                  />
                )}
              />
              <TextField
                margin="dense"
                id="remarks"
                label="Remarks"
                type="text"
                fullWidth
                multiline
                rows={4}
                value={formik.values.remarks}
                onChange={formik.handleChange}
                error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                helperText={formik.touched.remarks && formik.errors.remarks}
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateTimePicker"]}>
                  <DateTimePicker
                    label="Next Follow-up Date"
                    format="LL hh:mm a"
                    value={formik.values.nextFollowUpDate}
                    onChange={(newValue) => {
                      formik.setFieldValue("nextFollowUpDate", newValue);
                    }}
                    slotProps={{
                      textField: {
                        error:
                          formik.touched.nextFollowUpDate &&
                          Boolean(formik.errors.nextFollowUpDate),
                        helperText:
                          formik.touched.nextFollowUpDate &&
                          formik.errors.nextFollowUpDate,
                        fullWidth: true,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className={styles.cancelBtn}>
              Cancel
            </Button>
            <Button type="submit" className={styles.button}>
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default AddNewFollowUp;
